import { render } from "./PartnersSidebar.vue?vue&type=template&id=db7e50ee&ts=true"
import script from "./PartnersSidebar.vue?vue&type=script&lang=ts"
export * from "./PartnersSidebar.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__